import { useEffect } from "react";
import { createPortal } from "react-dom";

/**
 * Lightweight yes/cancel confirmation popup (no type-to-confirm).
 * Use for low-stakes, reversible-enough actions like deleting a single task.
 */
export default function ConfirmModal({
  open,
  title,
  description,
  confirmLabel = "Confirm",
  cancelLabel = "Cancel",
  danger = false,
  onConfirm,
  onCancel,
}) {
  useEffect(() => {
    if (!open) return;
    const h = (e) => {
      if (e.key === "Escape") onCancel();
      if (e.key === "Enter") onConfirm();
    };
    window.addEventListener("keydown", h);
    return () => window.removeEventListener("keydown", h);
  }, [open, onCancel, onConfirm]);

  if (!open) return null;

  return createPortal(
    <div className="modal-backdrop" onClick={onCancel}>
      <div className="modal-card" onClick={(e) => e.stopPropagation()} role="dialog" aria-modal="true" style={{ maxWidth: 460 }}>
        <h3>{title}</h3>
        {description && <p className="muted" style={{ marginTop: 8 }}>{description}</p>}
        <div className="row-h" style={{ justifyContent: "flex-end", marginTop: 20, gap: 8 }}>
          <button type="button" onClick={onCancel}>{cancelLabel}</button>
          <button
            type="button"
            className={danger ? "primary danger-action" : "primary"}
            onClick={onConfirm}
            autoFocus
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
}
